"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntervalMap = exports.Interval = void 0;

var _IntervalMap;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Intervals
var Interval;
exports.Interval = Interval;

(function (Interval) {
  Interval["SECONDS"] = "s";
  Interval["MINUTES"] = "m";
  Interval["HOURS"] = "h";
  Interval["DAYS"] = "d";
})(Interval || (exports.Interval = Interval = {}));

var IntervalMap = (_IntervalMap = {}, _defineProperty(_IntervalMap, Interval.SECONDS, 1), _defineProperty(_IntervalMap, Interval.MINUTES, 2), _defineProperty(_IntervalMap, Interval.HOURS, 3), _defineProperty(_IntervalMap, Interval.DAYS, 4), _IntervalMap);
exports.IntervalMap = IntervalMap;